import React from 'react';
import { Alert, Button, Typography } from 'antd';
import { lifeCycleEntitiesMap } from '../../constants/lifeCycle';

const entityLabels = {
  [lifeCycleEntitiesMap.stage]: {
    items: 'стадии',
    displayed: 'отображаемой стадии',
  },
  [lifeCycleEntitiesMap.step]: {
    items: 'этапы',
    displayed: 'отображаемому этапу',
  },
  [lifeCycleEntitiesMap.acceptanceStatus]: {
    items: 'результаты приемки',
    displayed: 'отображаемому результату приемки',
  },
};

const FetchLifeCycleOptionsErrorAlert = ({ refetch, entity, canChange }) => {
  const label = entityLabels[entity];

  const description = (
    <Typography>
      {Boolean(label && canChange) && (
        <Typography.Paragraph>
          Доступные для выбора {label.items} могут не соответствовать{' '}
          {label.displayed} помещения
        </Typography.Paragraph>
      )}
      <Button onClick={refetch} type="primary">
        Повторить
      </Button>
    </Typography>
  );

  return (
    <Alert
      closable
      message="Не удалось получить актуальное состояние жизненного цикла помещения"
      type="warning"
      description={description}
    />
  );
};

export default FetchLifeCycleOptionsErrorAlert;
